export default "__VITE_ASSET__DJ2Q43hl__"